import api from "./api";

export const apiManagementService = {
  // 🆕 NEW: Direct API Key Management (Simplified Approach)
  createApiKeyDirect: async (keyData) => {
    const response = await api.post("/api-management/keys", keyData);
    return response.data;
  },

  getAllApiKeys: async () => {
    const response = await api.get("/api-management/keys");
    return response.data;
  },

  revokeApiKeyDirect: async (keyId) => {
    const response = await api.delete(`/api-management/keys/${keyId}`);
    return response.data;
  },

  regenerateApiKey: async (keyId) => {
    const response = await api.post(`/api-management/keys/${keyId}/regenerate`);
    return response.data;
  },

  // 🔧 FIXED: Client Management (kept for backward compatibility)
  createClient: async (clientData) => {
    const response = await api.post("/api-management/clients", clientData);
    return response.data;
  },

  getClients: async () => {
    const response = await api.get("/api-management/clients");
    return response.data;
  },

  getClientById: async (clientId) => {
    const response = await api.get(`/api-management/clients/${clientId}`);
    return response.data;
  },

  updateClient: async (clientId, updateData) => {
    const response = await api.put(
      `/api-management/clients/${clientId}`,
      updateData,
    );
    return response.data;
  },

  deleteClient: async (clientId) => {
    const response = await api.delete(`/api-management/clients/${clientId}`);
    return response.data;
  },

  // 🔧 FIXED: API Key Management (legacy client-based approach)
  createApiKey: async (keyData) => {
    const response = await api.post("/api-management/clients/keys", keyData);
    return response.data;
  },

  getApiKeys: async (clientId) => {
    const params = new URLSearchParams();
    if (clientId) params.append("client_id", clientId);
    const response = await api.get(
      `/api-management/clients/keys?${params.toString()}`,
    );
    return response.data;
  },

  getKeyById: async (keyId) => {
    const response = await api.get(`/api-management/keys/${keyId}`);
    return response.data;
  },

  updateKey: async (keyId, updateData) => {
    const response = await api.put(`/api-management/keys/${keyId}`, updateData);
    return response.data;
  },

  revokeKey: async (keyId) => {
    const response = await api.delete(`/api-management/keys/${keyId}`);
    return response.data;
  },

  regenerateKey: async (keyId) => {
    const response = await api.post(`/api-management/keys/${keyId}/regenerate`);
    return response.data;
  },

  // Usage Analytics (placeholders for now)
  getClientUsage: async (clientId) => {
    const response = await api.get(`/api-management/clients/${clientId}/usage`);
    return response.data;
  },

  getKeyUsage: async (keyId) => {
    const response = await api.get(`/api-management/keys/${keyId}/usage`);
    return response.data;
  },

  getUsageOverview: async () => {
    const response = await api.get("/api-management/usage/overview");
    return response.data;
  },

  getUsageAnalytics: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.period) params.append("period", filters.period);
    if (filters.client_id) params.append("client_id", filters.client_id);
    if (filters.key_id) params.append("key_id", filters.key_id);
    if (filters.date_from) params.append("date_from", filters.date_from);
    if (filters.date_to) params.append("date_to", filters.date_to);

    const queryString = params.toString();
    const url = queryString
      ? `/api-management/usage/analytics?${queryString}`
      : "/api-management/usage/analytics";
    const response = await api.get(url);
    return response.data;
  },

  getUsageData: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.offset) params.append("offset", filters.offset);

    const queryString = params.toString();
    const url = queryString
      ? `/api-management/usage?${queryString}`
      : "/api-management/usage";
    const response = await api.get(url);
    return response.data;
  },
};
